import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Grid, Button, CircularProgress } from '@mui/material';
import SiteContent from '../components/SiteContent';
import { useTranslation } from 'react-i18next';
import { apiService } from '../services/apiService';

const Site = () => {
    const { t } = useTranslation();
    const { slug } = useParams();
    const navigate = useNavigate();
    const [userData, setUserData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showSite, setShowSite] = useState(false);

    useEffect(() => {
        const fetchUserBySlug = async () => {
            try {
                const data = await apiService.getUserBySlug(slug);
                if (!data || !data.isActive) {
                    navigate('/');
                } else {
                    setUserData(data);
                }
            } catch (error) {
                console.error(t('error_get_user_by_slug'), error);
                navigate('/');
            } finally {
                setLoading(false);
            }
        };

        if (slug) fetchUserBySlug();
    }, [slug, navigate]);

    if (loading) {
        return (
            <Grid container display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress />
            </Grid>
        );
    }

    return (
        <Grid container display="flex" justifyContent="center" alignItems="center">
            {showSite ? (
                <Grid item xs={12} sm={8} md={6} sx={{ py: 4 }}>
                    <SiteContent
                        planId={userData.planId}
                        imageUrls={userData.imageUrls || []}
                        message={userData.message}
                        startDateTime={userData.startDateTime}
                        videoAutoplay={showSite}
                        videoUrl={userData.youTubeUrl || ''}
                    />
                </Grid>
            ) : (
                <Grid item xs={12} display="flex" justifyContent="center" alignItems="center" height="100vh">
                    <Button
                        onClick={() => setShowSite(true)}
                        variant="contained"
                        sx={{
                            borderColor: '#f03093',
                            color: '#fff',
                            fontSize: '1.75rem',
                            px: 4
                        }}
                    >
                        {t('button_click_label')}
                    </Button>
                </Grid>
            )}
        </Grid>
    );
};

export default Site;